import { render, staticRenderFns } from "./ModalCampaignCohort.vue?vue&type=template&id=72ac8f6d"
import script from "./ModalCampaignCohort.vue?vue&type=script&lang=js"
export * from "./ModalCampaignCohort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports